export interface PortEntity {

    id?: number | null,
    portCode?: string | null,
    effectiveDate?: Date | null,
    portName?: string | null,
    portEncodeScheme?: string | null,
    expiryDate?: Date | null,
    countryCodeId?: string | null,
    countryCode?: string | null,
    provinceCodeId?: string | null,
    provinceCode?: string | null,
    geogInd?: string | null,
    geographicalIndDesc?: string | null,
    createBy?: string | null,
    activeInd: string | null,
    mappingType: string,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_PORT_ENTITY: PortEntity = {

    id: 0,
    portCode: '',
    effectiveDate: null,
    portName: '',
    portEncodeScheme: '',
    expiryDate: null,
    countryCodeId: '',
    countryCode: '',
    provinceCodeId: '',
    provinceCode: '',
    geogInd: '',
    geographicalIndDesc: '',
    createBy: 'By Manual',
    activeInd: 'Y',
    mappingType: "PortEntity",

}
